import { makeHttpRequest } from "@/shared";

export const getLanguages = async () => {
    const response = await makeHttpRequest({
        url: "languages",
        method: "get",
    });

    return response?.data?.data;
};
